import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Table.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const List = () => {
  const [rows, setRows] = useState([]); // Initialisation avec un tableau vide
  const [loading, setLoading] = useState(true); // Gestion de chargement
  const [error, setError] = useState(null); // Gestion des erreurs

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const response = await axios.get("http://localhost:5000/api/orders/payments");
        setRows(response.data); // Assurez-vous que response.data est un tableau
      } catch (err) {
        console.error("Erreur lors de la récupération des données :", err);
        setError("Une erreur s'est produite lors de la récupération des paiements.");
      } finally {
        setLoading(false);
      }
    };

    fetchPayments();
  }, []);

  if (loading) return <p>Chargement des paiements...</p>;
  if (error) return <p>{error}</p>;

  return (
    <TableContainer component={Paper} className="table">
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell className="tableCell"><strong>Clients</strong></TableCell>
            <TableCell className="tableCell"><strong>Date</strong></TableCell>
            <TableCell className="tableCell"><strong>Montant</strong></TableCell>
            <TableCell className="tableCell"><strong>Status</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.uid}>
            
              <TableCell className="tableCell">{row.useremail}</TableCell>
              <TableCell className="tableCell">{row.createdAt}</TableCell>
              <TableCell className="tableCell">{row.totalPrice}</TableCell>
              <TableCell className="tableCell">
                <span className={`status ${row.paymentStatus.toLowerCase()}`}>{row.paymentStatus}</span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default List;
